<template>
  <el-dialog v-if="dialogVisible" :title="$t('billingPage.ChoseCategories')" :visible.sync="dialogVisible" width="1100px" :before-close="handleCancel">
    <el-form :inline="true">
      <div style="padding: 0 20px;">
        <el-form-item :label="$t('billingPage.searchName')">
          <BjInput v-model="keywords" :placeholder="$t('inputText')" clearable />
        </el-form-item>
        <el-button type="primary" style="margin-left:10px" @click="search">{{ $t('searchText') }}</el-button>
      </div>
      <div style="height: 70vh;overflow-y: auto;padding: 0 20px;">
        <div v-for="(item,index) in tableList" :key="index">
          <BjDivider>{{ item.group }}
            <div slot="right" class="flex-align">
              <el-button icon="el-icon-arrow-up" circle :disabled="!item.show" @click="hiddenList(item)"></el-button>
              <el-button icon="el-icon-arrow-down" :disabled="item.show" circle @click="openList(item)"></el-button>
            </div>
          </BjDivider>
          <transition name="el-fade-in-linear">
            <el-table v-show="item.show" :id="`toggleTable${index}`" :ref="`toggleTable${index}`" :data="item.billCategories" style="width: 100%" border @selection-change="handleSelectionChange($event, index)">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="billCategoryName" :label="$t('billingPage.name')" align="center" min-width="100"></el-table-column>
              <el-table-column prop="billCategoryCode" :label="$t('billingPage.code')" align="center" min-width="100"></el-table-column>
              <el-table-column prop="description" :label="$t('billingPage.description')" align="center" min-width="200"></el-table-column>
              <el-table-column prop="tags" :label="$t('billingPage.tag')" align="center" min-width="80"></el-table-column>
            </el-table>
          </transition>
        </div>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer" style="padding: 0 20px;">
      <el-button @click="handleCancel">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="handleSend">{{ $t('okText') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    tableList: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },
  data() {
    return {
      dialogVisible: false,
      keywords: ''
    };
  },
  computed: {
    dataList() {
      return this.tableList.map(item => {
        return { ...item, show: true, billCategories: [] };
      });
    }
  },
  methods: {
    search() {
      this.$emit('search', this.keywords);
    },
    toggleSelection(arr) {
      this.tableList.forEach((item, index) => {
        item.billCategories.forEach(row => {
          if (arr.some(jitem => jitem == row.billCategoryCode)) {
            this.$refs[`toggleTable${index}`][0].toggleRowSelection(row);
          }
        });
      });
    },
    hiddenList(item) {
      item.show = false;
    },
    openList(item) {
      item.show = true;
    },
    handleSelectionChange(row, index) {
      this.dataList[index].billCategories = row;
    },
    handleCancel() {
      this.keywords = '';
      this.dialogVisible = false;
      this.$emit('search', this.keywords);
    },
    handleSend() {
      this.handleCancel();
      this.$emit('submit', this.dataList);
    },
  },
};
</script>
